import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const StyledTd = /*#__PURE__*/_styled("td", {
  target: "e14edshc0",
  label: "StyledTd"
})(process.env.NODE_ENV === "production" ? {
  name: "l1hg2r",
  styles: "border:1px solid black;padding:8px;text-align:left"
} : {
  name: "l1hg2r",
  styles: "border:1px solid black;padding:8px;text-align:left/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9SaWNodGV4dENvbnRyb2wvY29tcG9uZW50cy9FbGVtZW50L1RhYmxlQ2VsbEVsZW1lbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTBCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uLy4uL3NyYy9SaWNodGV4dENvbnRyb2wvY29tcG9uZW50cy9FbGVtZW50L1RhYmxlQ2VsbEVsZW1lbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IFN0eWxlZFRkID0gc3R5bGVkLnRkYFxuICBib3JkZXI6IDFweCBzb2xpZCBibGFjaztcbiAgcGFkZGluZzogOHB4O1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuYDtcblxuZnVuY3Rpb24gVGFibGVDZWxsRWxlbWVudCh7IGNoaWxkcmVuLCBhdHRyaWJ1dGVzLCBub2RlUHJvcHMgfSkge1xuICByZXR1cm4gKFxuICAgIDxTdHlsZWRUZCB7Li4uYXR0cmlidXRlc30gey4uLm5vZGVQcm9wc30+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9TdHlsZWRUZD5cbiAgKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgVGFibGVDZWxsRWxlbWVudDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function TableCellElement({
  children,
  attributes,
  nodeProps
}) {
  return _jsx(StyledTd, {
    ...attributes,
    ...nodeProps,
    children: children
  });
}
export default TableCellElement;